const createEnvironmentFlags = (development = false, staging = false, production = false) => ({
  development,
  staging,
  production,
});

export const RW_NONFAV_QUICK_SIGNUP = 'rw-nonfav-quick-signup';
export const RW_FAV_QUICK_SIGNUP = 'rw-fav-quick-signup';
export const BOOKED_VENDOR_SIGNUP = 'booked-vendor-signup';
export const VENDOR_SAVED_SEARCH_SIGNUP = 'vendor-saved-search-signup';

export const FLAGS = {
  fontRenderFix: createEnvironmentFlags(true, true, false), // INVITES-1054
  newPlpCardTile: createEnvironmentFlags(false, false, false), // INV-501
  confirmExitModalFlag: createEnvironmentFlags(true, true, false), // WEDDINGS-1785
  invitesSinglesampleSaveToDraftsOnExit: createEnvironmentFlags(false, false, false), // INV-1265
  expeditedShippingModal: createEnvironmentFlags(false, false, false), // INV-1439
  singleSampleEnvelopes: createEnvironmentFlags(true, true, false), // INV-1588
  albumsFTERedesign: createEnvironmentFlags(true, true, true), // COMMERCE-503
  albumsGenerateWithoutPayload: createEnvironmentFlags(true, true, true), // COMMERCE-621
  albumsPDPHover: createEnvironmentFlags(true, true, true), // COMMERCE-162
  envelopeLinerA2: createEnvironmentFlags(true, true, true), // COMMERCE-703
  seoColorSeasonFilters: createEnvironmentFlags(true, true, true), // COMMERCE-461
  albumsPricingBreakdown: createEnvironmentFlags(true, true, true), // COMMERCE-482
  datadog: createEnvironmentFlags(false, true, true), // Toggle datadog monitoring
  cardsOutOfStock: createEnvironmentFlags(true, true, true), // COMMERCE-588
  cardsSortBy: createEnvironmentFlags(true, true, true), // COMMERCE-652
  cardsFavoriting: createEnvironmentFlags(true, true, true), // COMMERCE-639
  showHolidayShippingReminder: createEnvironmentFlags(false, false, false), // COMMERCE-922
  cardsSampleFlow: createEnvironmentFlags(true, true, false), // COMMERCE-1014
  websiteToUploadcare: createEnvironmentFlags(true, true, true), // CE-1539
  dstdWebsiteEntry: createEnvironmentFlags(true, true, true), // COMMERCE-1072
  dstdUnavailable: createEnvironmentFlags(true, true, true), // COMMERCE-1103
  reviewQuantityUpdate: createEnvironmentFlags(true, true, true), // COMMERCE-1142
  updateProductViewedEvent: createEnvironmentFlags(true, true, true), // COMMERCE-1177
  envelopeGuestAddressingTextResets: createEnvironmentFlags(false, false, false), // COMMERCE-1153 follow up
  updateAlbumViewedEvent: createEnvironmentFlags(true, true, true), // COMMERCE-1177
  csvUploadMapInModal: createEnvironmentFlags(true, true, true), // COMMERCE-1218
  cardsExtraCustomization: createEnvironmentFlags(true, true, true), // COMMERCE-1387
  resetCustomizationButton: createEnvironmentFlags(false, false, false), // COMMERCE-1476
  fullSuitePLP: createEnvironmentFlags(true, true, true), // COMMERCE-1449
  invitesHeroAnimated: createEnvironmentFlags(true, true, true), // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-1594
  dstdAnimations: createEnvironmentFlags(true, true, true), // COMMERCE-1611
  cardsPlpSeoFaq: createEnvironmentFlags(true, true, true), // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-1714
  cardsPlpSeoSchemas: createEnvironmentFlags(true, true, true), // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-1602
  dstdEmailTemplate: createEnvironmentFlags(true, true, true), // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-1665
  newPaperShapes: createEnvironmentFlags(true, true, true), // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-1637
  newPaperShapesPLPFilter: createEnvironmentFlags(true, true, true), // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-1860
  newPaperShapesConfirmation: createEnvironmentFlags(true, true, false), // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-2081
  cardsReversePrinting: createEnvironmentFlags(true, true, true), // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-2179
  cardsAdditionalLayouts: createEnvironmentFlags(true, true, true), // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-2384
  plpPhotoPreview: createEnvironmentFlags(true, true, true), // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-2107
  plpPhotoPreviewSamplesFlow: createEnvironmentFlags(true, true, true), // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-2107
  cardsPlpFullWidthPromoHero: createEnvironmentFlags(true, true, false), // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-2231
  yourWeddingRebrand: createEnvironmentFlags(true, true, true), // https://newamsterdamlabs.atlassian.net/browse/CE-2314
  plpRedesign: createEnvironmentFlags(true, true, true), // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-2250
  plpShapesPreviewAndFiltering: createEnvironmentFlags(true, true, true), // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-2186
  thankYouNoteFonts: createEnvironmentFlags(true, true, true), // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-2238
  cardsQRCodeExpansion: createEnvironmentFlags(true, true, true), // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-2399
  cardsYodOrdersPreviews: createEnvironmentFlags(true, true, true), // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-2564
  albumCheckoutQuantity: createEnvironmentFlags(true, true, true), //  https://newamsterdamlabs.atlassian.net/browse/COMMERCE-2606
  backOfEnvelope: createEnvironmentFlags(true, true, true), // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-2491
  websiteV2MobileImgs: createEnvironmentFlags(true, true, true),
  paperFavoriteQuickSignup: createEnvironmentFlags(true, true, true), // https://newamsterdamlabs.atlassian.net/browse/CE-3115
  communityQuickSignup: createEnvironmentFlags(true, true, true), // https://newamsterdamlabs.atlassian.net/browse/CE-3112
  paperZendeskChat: createEnvironmentFlags(true, true, true),
  vendorFavoriteQuickSignup: createEnvironmentFlags(true, true, true), // https://newamsterdamlabs.atlassian.net/browse/CE-3114
  weddingWebsiteQuickSignupUpdate: createEnvironmentFlags(true, true, true), // https://newamsterdamlabs.atlassian.net/browse/CE-3058
  shopHolidays2022: createEnvironmentFlags(false, false, false),
  paperInvitationsPetite: createEnvironmentFlags(true, true, true),
  cardsCustFlowThemePicker: createEnvironmentFlags(true, true, true),
  ywDashboardAllUsers: createEnvironmentFlags(true, true, true), // https://newamsterdamlabs.atlassian.net/browse/CE-2945
  websiteImageSizeStandardizing: createEnvironmentFlags(true, true, true), // https://newamsterdamlabs.atlassian.net/browse/CE-2887
  cardsCustomizationFlowImprovements: createEnvironmentFlags(true, true, true), // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-2724
  mobilePLP: createEnvironmentFlags(true, true, true), // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-2685
  disneyWeddingWebsite: createEnvironmentFlags(true, true, true), // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-2770
  paperRegistryTile: createEnvironmentFlags(true, true, true),
  websiteV2RichPreview: createEnvironmentFlags(true, true, false),
  onboardingWebsiteV2LivePreview: createEnvironmentFlags(false, false, false),
  paperGuestAddressingConfirmationModal: createEnvironmentFlags(false, false, false), // Don't delete. Waiting for guest addressing experiment to be over before reenabling.
  paperNewCloningEndpoint: createEnvironmentFlags(true, true, true),
  paperDetailPageV2: createEnvironmentFlags(true, true, true),
  paperLineHeightFix: createEnvironmentFlags(true, true, true), // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-2006
  paperDSTDv2: createEnvironmentFlags(true, true, true),
  paperNewPLPAdTiles: createEnvironmentFlags(true, true, true),
  [RW_NONFAV_QUICK_SIGNUP]: createEnvironmentFlags(true, true, true), // https://newamsterdamlabs.atlassian.net/browse/CE-3113
  [RW_FAV_QUICK_SIGNUP]: createEnvironmentFlags(true, true, true), // https://newamsterdamlabs.atlassian.net/browse/CE-3178
  guestRsvpShowForm: createEnvironmentFlags(true, true, true), // https://newamsterdamlabs.atlassian.net/browse/CE-3130
  eventFormEndTimeValidation: createEnvironmentFlags(true, true, true), // https://newamsterdamlabs.atlassian.net/browse/CE-3027
  cardsOnboardBgScrollFix: createEnvironmentFlags(true, true, true), // https://newamsterdamlabs.atlassian.net/browse/CE-3126
  weddingWebsiteFullOnboard: createEnvironmentFlags(true, true, false), // https://newamsterdamlabs.atlassian.net/browse/CE-3204
  replaceGeosuggest: createEnvironmentFlags(true, true, false), // https://newamsterdamlabs.atlassian.net/browse/CE-2897
  guestListFullOnboard: createEnvironmentFlags(true, true, false), // https://newamsterdamlabs.atlassian.net/browse/CE-3206
  paperFullOnboard: createEnvironmentFlags(true, true, false), // https://newamsterdamlabs.atlassian.net/browse/CE-3205
  [BOOKED_VENDOR_SIGNUP]: createEnvironmentFlags(true, true, false), // https://newamsterdamlabs.atlassian.net/browse/CE-3250
  [VENDOR_SAVED_SEARCH_SIGNUP]: createEnvironmentFlags(true, true, false), // https://newamsterdamlabs.atlassian.net/browse/CE-3178
  virtualEventDateFix: createEnvironmentFlags(true, true, true), // https://newamsterdamlabs.atlassian.net/browse/CE-3286
  bookedVendorV2Endpoint: createEnvironmentFlags(true, true, false),
};

type Environments = 'development' | 'staging' | 'production';
export const getEnvironment = (): Environments => {
  const zolaEnv: string | undefined =
    (typeof window !== 'undefined' && window.zola && window.zola.env) ||
    process.env.ZOLA_ENV ||
    process.env.NODE_ENV;
  switch (zolaEnv) {
    case 'test':
    case 'development':
    case 'dev':
      return 'development';
    case 'staging':
    case 'stage':
      return 'staging';
    case 'production':
    case 'prod':
      return 'production';
    default:
      return 'production';
  }
};

export type FeatureFlag = keyof typeof FLAGS;

const get = (flag: FeatureFlag): boolean => {
  if (FLAGS[flag]) {
    return Boolean(FLAGS[flag][getEnvironment()]);
  }
  return false;
};

export default {
  get,
  getEnvironment,
};
